export const pdlfilefetch = async (endpoint: string) => {
  const controller = new AbortController();
  const terminateEarly = setTimeout(() => controller.abort(), 10000);

  const response = await fetch(endpoint, {
    method: 'GET',
    signal: controller.signal,
  });
  clearTimeout(terminateEarly);
  if (!response.ok) {
    throw new Error('pdlfilefetch call - response was not OK');
  }
  return response.text();
};

export const pdljsonfetch = async (endpoint: string) => {
  const controller = new AbortController();
  const terminateEarly = setTimeout(() => controller.abort(), 10000);

  const response = await fetch(endpoint, {
    method: 'GET',
    signal: controller.signal,
  });
  clearTimeout(terminateEarly);
  if (!response.ok) {
    throw new Error('pdljsonfetch call - response was not OK');
  }
  return response.json();
};

export default pdlfilefetch;
